import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';

export function TruncatedFragment({
  content,
  minHeight,
  contentClassName,
  btnClassName,
  btnContainerClassName,
  btnTextClassName,
  expandText,
  collapseText,
  ariaLabelHeading,
  resetParams,
  btnTrackingId,
  isHtml,
  isTruncated,
}) {
  const [isCollapsible, setCollapsible] = useState(isTruncated);
  const contentRef = React.useRef();

  useEffect(() => {
    if (isTruncated) {
      setCollapsible(
        get(contentRef, 'current.container.clientHeight', get(contentRef, 'current.clientHeight', 0)) > minHeight
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const className = classnames('truncated-content', contentClassName);
  const contentFragment = isHtml ? (
    <ContentFragment classes={className} ref={contentRef}>
      {content}
    </ContentFragment>
  ) : (
    <div className={className} ref={contentRef}>
      {content}
    </div>
  );

  return isCollapsible ? (
    <ContentCollapse
      minHeight={`${minHeight}px`}
      textClosed={expandText}
      textOpen={collapseText}
      justify="justify-content-start"
      btnClasses={classnames('me-0_25 p-0', btnClassName)}
      btnContainerClasses={classnames('px-0_5', btnContainerClassName)}
      btnTextClasses={classnames('fw-normal size-16', btnTextClassName)}
      btnArrowClasses="size-10 text-primary-darker"
      showBtnBelow
      isEclipseFade={false}
      btnTrackingId={btnTrackingId}
      resetParams={resetParams}
      ariaLabelHeading={ariaLabelHeading}
    >
      {contentFragment}
    </ContentCollapse>
  ) : (
    contentFragment
  );
}

TruncatedFragment.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  contentClassName: PropTypes.string,
  btnClassName: PropTypes.string,
  btnContainerClassName: PropTypes.string,
  btnTextClassName: PropTypes.string,
  expandText: PropTypes.string,
  collapseText: PropTypes.string,
  ariaLabelHeading: PropTypes.string,
  btnTrackingId: PropTypes.string,
  minHeight: PropTypes.number,
  isTruncated: PropTypes.bool,
  isHtml: PropTypes.bool,
  resetParams: PropTypes.shape({
    offset: PropTypes.number,
    duration: PropTypes.number,
    to: PropTypes.string,
  }),
};

TruncatedFragment.defaultProps = {
  expandText: 'See more',
  collapseText: 'See less',
  ariaLabelHeading: null,
  btnClassName: null,
  btnContainerClassName: 'mt-1',
  btnTextClassName: 'text-primary-darker',
  contentClassName: null,
  btnTrackingId: null,
  minHeight: 0,
  isHtml: false,
  isTruncated: true,
  resetParams: null,
};
